'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagVaAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M28 0L13.5 0V20L28 20V0Z", fill: "white" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M24.9092 11.5286C25.6903 12.3096 25.6903 13.576 24.9092 14.357C24.1282 15.1381 22.8618 15.1381 22.0808 14.357C21.465 13.7412 21.3347 12.8239 21.6899 12.0805L18.781 9.17155L17.8382 10.1144L16.8953 9.17155L18.781 7.28594L22.6327 11.1376C23.3761 10.7825 24.2935 10.9128 24.9092 11.5286Z",
          fill: "#CDCCCC"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M18.701 11.1376C17.9576 10.7825 17.0402 10.9128 16.4245 11.5286C15.6434 12.3096 15.6434 13.576 16.4245 14.357C17.2055 15.1381 18.4719 15.1381 19.2529 14.357C19.8687 13.7412 19.999 12.8239 19.6439 12.0805L22.5527 9.17155L23.4956 10.1144L24.4384 9.17155L22.5527 7.28594L18.701 11.1376Z",
          fill: "#CD9D25"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M20.6668 6.66667C19.5623 6.66667 18.6668 6.36819 18.6668 6C18.6668 5.63181 19.5623 5.33333 20.6668 5.33333C21.7714 5.33333 22.6668 5.63181 22.6668 6C22.6668 6.36819 21.7714 6.66667 20.6668 6.66667ZM20.6668 3.33333C20.1145 3.33333 19.6668 3.18409 19.6668 3C19.6668 2.81591 20.1145 2.66667 20.6668 2.66667C21.2191 2.66667 21.6668 2.81591 21.6668 3C21.6668 3.18409 21.2191 3.33333 20.6668 3.33333ZM20.6668 4.88889C19.9305 4.88889 19.3335 4.6899 19.3335 4.44444C19.3335 4.19899 19.9305 4 20.6668 4C21.4032 4 22.0002 4.19899 22.0002 4.44444C22.0002 4.6899 21.4032 4.88889 20.6668 4.88889Z",
          fill: "#CD9D25"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M17.3679 14.2108C17.4753 14.5331 17.6981 14.9787 18.0715 15.4268C18.7109 16.194 19.5774 16.6667 20.667 16.6667C21.7566 16.6667 22.6231 16.194 23.2625 15.4268C23.6359 14.9787 23.8587 14.5331 23.9661 14.2108C24.0826 13.8615 23.8938 13.484 23.5445 13.3676C23.1952 13.2511 22.8177 13.4399 22.7012 13.7892C22.642 13.9669 22.4898 14.2713 22.2382 14.5732C21.8359 15.056 21.3274 15.3334 20.667 15.3334C20.0066 15.3334 19.4981 15.056 19.0958 14.5732C18.8442 14.2713 18.692 13.9669 18.6328 13.7892C18.5164 13.4399 18.1388 13.2511 17.7895 13.3676C17.4402 13.484 17.2515 13.8615 17.3679 14.2108Z",
          fill: "#F5252C"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M13.5 20L28 20V0L13.5 0L13.5 0.499977L27.5 0.5V19.5H13.5L13.5 20Z",
          fill: "#8996A2"
        }
      ),
      /* @__PURE__ */ jsx("path", { d: "M0 0L13.5 0V20H0V0Z", fill: "#FDE048" })
    ]
  }
);
const VpFlagVaAsset = forwardRef(FlagVaAsset);

export { VpFlagVaAsset as default };
